import React, { useRef, useState, useEffect } from "react";
import { Box, Grid, Typography, Button, Divider } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup"; // Import Yup for validation
import CloseIcon from "@mui/icons-material/Close";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarTodayRoundedIcon from "@mui/icons-material/CalendarTodayRounded";
import CryptoJS from "crypto-js";
import { encryptData } from "../../utils/cryptoUtils";

import dayjs from "dayjs";
import {
  postPublicHoliday,
  updatePublicHoliday,
} from "../../services/publicHoliday.service";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";

const AddPublicHoliday = (props) => {
  const { selectedData, formType, setOpenDrawer, GetData } = props;
  const disabled = formType === "view";
  const formRef = useRef(null);

  const [initialValues, setInitialValues] = useState({
    name: "",
    date: "",
    description: "",
  });

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    date: Yup.string().required("Select the Date"),
    description: Yup.string().required("Enter Description"),
  });

  useEffect(() => {
    if (formType === "view" || formType === "edit") {
      setInitialValues({
        name: selectedData.name || "",
        date: selectedData.date || "",
        description: selectedData.description || "",
      });
    }
  }, [formType, selectedData]);

  const onSubmit = async (values) => {
    try {
      const encryptedData = {
        name: encryptData(values.name),
        date: values.date,
        description: encryptData(values.description),
      };
      const apiMethod =
        formType === "edit"
          ? updatePublicHoliday(selectedData._id, encryptedData)
          : postPublicHoliday(encryptedData);
      const res = await apiMethod;
      setOpenDrawer(false);
      ToastSuccess(res.message);
      GetData();
    } catch (error) {
      ToastError(error?.data?.message);
    }
  };
  return (
    <div className="addRenderingPopup">
      <Box className="addContainerHeader">
        <Typography sx={{ fontSize: "16px", fontWeight: 700 }}>
          {formType === "edit" ? "Edit" : formType === "view" ? "View" : "Add"}{" "}
          Public Holiday
        </Typography>
        <CloseIcon
          className="Close-Icon"
          onClick={() => setOpenDrawer(false)}
        />
      </Box>
      <Divider sx={{ opacity: 1 }} />
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={onSubmit}
        innerRef={formRef}
      >
        {({ touched, errors, setFieldValue, values }) => (
          <Form>
            <Box className="addContainerCenter" mb={1}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">
                    Name <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Field
                    name="name"
                    className="InputField"
                    placeholder="Enter Event Name"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.name && errors.name && errors.name}
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} mt={1}>
                  <Typography className="inputLabel">
                    Event Date <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker", "DatePicker"]}>
                      <DatePicker
                        value={values?.date ? dayjs(values?.date) : null}
                        onChange={(e) => setFieldValue("date", e.$d)}
                        className="datePicker w-100"
                        format="DD/MM/YYYY"
                        disabled={disabled}
                        slots={{
                          openPickerIcon: CalendarTodayRoundedIcon,
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                  <div className="form-error">
                    {touched.date && errors.date && errors.date}
                  </div>
                </Grid>

                <Grid item xs={12} sm={12} mt={1}>
                  <Typography className="inputLabel">
                    Description <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Field
                    name="description"
                    className="InputField"
                    placeholder="Enter Description"
                    disabled={disabled}
                  />
                  <div className="form-error">
                    {touched.description &&
                      errors.description &&
                      errors.description}
                  </div>
                </Grid>
              </Grid>
            </Box>
            <Grid className="addboxFooter">
              <Button
                className="cancelButton"
                onClick={() => setOpenDrawer(false)}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                className="saveButton"
                sx={{ display: disabled ? "none" : "flex" }}
              >
                Save
              </Button>
            </Grid>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AddPublicHoliday;
